import { Col, Row } from "react-bootstrap";
import { Loader } from "../../components/common/progress/Loader";
import { usePlugin } from "../../components/plugins/contexts/PluginContext";
import { DeleteAction } from "../../components/plugins/models/DeleteAction";
import { SideNavbar } from "../../components/plugins/SideNavbar";
import { useVersion } from "../../components/plugins/contexts/VersionContext";
import { VersionDetailsForm } from "../../components/plugins/VersionDetailsForm";
import { DeleteVersionButtonGroup } from "../../components/plugins/DeleteVersionButtonGroup";
import { VersionDetailsPartial } from "../../components/plugins/VersionDetailsPartial";
import { PluginVersionTabs } from "../../components/plugins/PluginVersionTabs";
import { PendingVersionButtonGroup } from "../../components/plugins/PendingVersionButtonGroup";
import { useEffect } from "react";
import { Status } from "../../components/plugins/models/Status";
import { useNavigate } from "react-router-dom";
import { NotFound } from "../NotFound";
import { routes } from "../../main/routes";
import { DownloadVersionButtonGroup } from "../../components/plugins/DownloadVersionButtonGroup";

export const PendingVersion = () => {
  const { isLoading, pluginDetails: plugin } = usePlugin();
  const { version } = useVersion();
  const navigate = useNavigate();
  const pendingVersion = version?.unpublishedPluginVersion ?? version;
  const hasUrl = !!version?.downloadDetails?.downloadUrl;

  useEffect(() => {
    if (pendingVersion && pendingVersion.status !== Status.InReview) {
      navigate(routes.versions.update(plugin.id, version.versionId, plugin.status));
    }
  }, [pendingVersion]);

  if (isLoading) return <Loader />;
  if (!pendingVersion) return <NotFound />;

  return (
    <VersionDetailsForm version={pendingVersion}>
      <Row>
        <Col xs={12} lg={4} style={{ borderRight: "1px solid lightgray" }}>
          <SideNavbar plugin={plugin} />
        </Col>
        <Col xs={12} lg={8}>
          <PluginVersionTabs />
          <VersionDetailsPartial enableFileUpload={pendingVersion.requiresSignature} />
          <div className="d-flex justify-content-between mb-2">
            <div className="d-flex">
              <PendingVersionButtonGroup />
              <DeleteVersionButtonGroup version={pendingVersion} futureInstructions={DeleteAction.One} />
            </div>
            {hasUrl && <DownloadVersionButtonGroup />}
          </div>
        </Col>
      </Row>
    </VersionDetailsForm>
  );
};
